export default __webpack_public_path__ + "static/media/check.494b1fab.svg";